import * as React from "react";
const SvgAddIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.25 11.25H0V12.75H11.25V24H12.75V12.75H24V11.25H12.75V0H11.25V11.25Z", fill: "currentColor" }));
export default SvgAddIcon;
